import React from 'react';
import { Link } from 'react-router-dom';

// Components
import ProductPreviewImage from './product/ProductPreviewImage';
import ProductPriceList from './product/ProductPriceList';

// CSS
import '../css/product-collection.css';

export default function ItemPreview({product, width, height}) {
	const catPermalink = product.categories ? product.categories[0].permalink + '/' : '/';

	return (
		<div className="product">
			<Link to={`/${catPermalink}product/${product.permalink}`}>
				<ProductPreviewImage
					product={product}
					width={width}
					height={height}
				/>
				<div className="product_title">{product.title}</div>
				<ProductPriceList product={product} getFirstVariant={true} />
			</Link>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/ItemPreview.js